import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const AlertOctagon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="alert-octagon" {...props} />;
};
